import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-warning-popup',
  templateUrl: './warning-popup.component.html',
  styleUrls: ['./warning-popup.component.scss']
})
export class WarningPopupComponent {
  @Input() message: string;
  @Input() okOnly:boolean = false;
  constructor(public activeModal: NgbActiveModal) {}
  confirm() {
    this.activeModal.close(true);  // Return true when confirmed
  }
  cancel() {
    this.activeModal.close(false); // Return false when canceled
  }
 }

